<template>
  <div>
    <video v-if="!error" ref="videoPlayer" class="video-js" width="100%" height="100%;"></video>
    <div class="error" v-if="error">
      <div class="error-text"><p v-html="error"></p></div>
    </div>
  </div>
</template>
<style src="./player.css"/>
<script>
import videojs from "video.js";
import lifecycle from "page-lifecycle";
import qualityLevels from "videojs-contrib-quality-levels";
import hlsQualitySelector from "videojs-hls-quality-selector";
import {uuid} from 'vue-uuid';
import axios from 'axios';

export default {
  name: "Player",
  data() {
    return {
      error: false,
      player: null,
      playtime: 0,
      loggedPlaytime: 0,
      defaultOptions: {
        autoplay: false,
        controls: true,
      },
      qualityLevels: [],
      unloaded: false,
      assetId: '',
      referrer: '',
      uuid: uuid.v4()
    };
  },

  async mounted() {

    this.referrer = (window.location != window.parent.location)
        ? document.referrer
        : document.location.href;
    try {
      let assetRoute = `https://dam.parenttv.com/assets/${this.$route.params.licenseKey}/${this.$route.params.assetId}`
      const asset = await axios.get(assetRoute)
          .then((response) => response.data)
          .catch((e) => {
            if (e.response) {
              switch (e.response.status) {
                case 401:
                  this.error = "Your provider is not authorized to present this video.";
                  break;
                case 404:
                  this.error = "The requested video could not be found.";
                  break;
                default:
                  this.error = "There was a problem with the playback of this video.";
              }
            }
          });
      if (asset) {
        this.assetId = asset.ref
        if (this.$route.query.v) {
          assetRoute = `https://dam.parenttv.com/assets/${this.$route.params.licenseKey}/${this.$route.params.assetId}?v=${this.$route.query.v}`
          const clip = await axios.get(assetRoute)
              .then((response) => response.data)
              .catch((e) => {
                if (e.response) {
                  switch (e.response.status) {
                    case 401:
                      this.error = "Your provider is not authorized to present this video.";
                      break;
                    case 404:
                      this.error = "The requested video could not be found.";
                      break;
                    default:
                      this.error = "There was a problem with the playback of this video.";
                  }
                }
              });
          if (asset._links.stream == clip._links.stream) {
            this.error = "Sorry, there isn't currently a clip available for this video.";
            return
          }
          asset._links.stream = clip._links.stream;
          this.assetId = clip.ref
        }
        asset._links.stream += `?uid=${this.uuid}`
        window.addEventListener('beforeunload', () => {
          this.unloaded = true
          const played = this.player.played();
          let playtime = 0 - this.loggedPlaytime;
          for (let i = 0; i < played.length; i++) {
            playtime += played.end(i) - played.start(i)
          }
          navigator.sendBeacon(
              "https://dam.parenttv.com/metrics/watchtime",
              JSON.stringify({
                asset_id: this.assetId,
                license: this.$route.params.licenseKey,
                watch_time: `${Math.round(playtime)}`,
                referrer: this.referrer,
                reason: "video-closed"
              })
          )

        })
        lifecycle.addEventListener('statechange', (e) => {
          if (this.unloaded) return
          if (e.originalEvent.type === 'visibilitychange' && e.newState === 'hidden') {
            const played = this.player.played();
            let playtime = 0 - this.loggedPlaytime;
            for (let i = 0; i < played.length; i++) {
              playtime += played.end(i) - played.start(i)
            }
            navigator.sendBeacon(
                "https://dam.parenttv.com/metrics/watchtime",
                JSON.stringify({
                  asset_id: this.assetId,
                  license: this.$route.params.licenseKey,
                  watch_time: `${Math.round(playtime)}`,
                  referrer: this.referrer,
                  reason: "visibilitychange"
                })
            )
            this.loggedPlaytime += playtime
          }
        });
        let options = this.defaultOptions;
        options.poster = asset.excerpts.poster ? asset.excerpts.poster._links.stream : null;
        options.sources = [
          {
            src: asset._links.stream,
            type: "application/x-mpegURL"
          }
        ]
        videojs.registerPlugin("qualityLevels", qualityLevels)
        videojs.registerPlugin("hlsQualitySelector", hlsQualitySelector)
        this.player = videojs(this.$refs.videoPlayer, options, function onPlayerReady() {
        });

        this.player.hlsQualitySelector({
          displayCurrentQuality: true,
        });

        this.player.qualityLevels()


        window.addEventListener('message', (e) => {
          e.preventDefault();
          if (e.data.action && e.data.action === 'getPlayTimes') {
            window.parent.postMessage({action: 'playtimes', data: this.player}, "*")
          }
        });


        this.player.on("play", () => {
          const played = this.player.played();
          const times = [];
          this.playtime = 0;
          for (let i = 0; i < played.length; i++) {
            this.playtime += played.end(i) - played.start(i)
            times.push({start: played.start(i), end: played.end(i)})

          }
          window.parent.postMessage({action: 'play'}, '*')
          window.parent.postMessage({action: 'playtimes', data: times}, "*")
        });
        this.player.on("ended", () => {
          console.log("PLAYER ENDED")
          const target = window.parent

          const played = this.player.played();
          const times = [];
          this.playtime = 0;
          for (let i = 0; i < played.length; i++) {
            this.playtime += played.end(i) - played.start(i)
            times.push({start: played.start(i), end: played.end(i)})

          }
          console.log(target)
          target.postMessage({action: 'ended', data: times}, "*")
        })
        this.player.on("timeupdate", () => {
          const played = this.player.played();
          const times = [];
          this.playtime = 0
          for (let i = 0; i < played.length; i++) {
            this.playtime += played.end(i) - played.start(i)
            times.push({start: played.start(i), end: played.end(i)})
          }
          window.parent.postMessage({action: 'playtimes', data: times}, "*")
        });
        this.player.on("pause", () => {

          const played = this.player.played();
          const times = [];

          this.playtime = 0
          for (let i = 0; i < played.length; i++) {
            this.playtime += played.end(i) - played.start(i)
            times.push({start: played.start(i), end: played.end(i)})
          }
          window.parent.postMessage({action: 'pause'}, '*')
          window.parent.postMessage({action: 'playtimes', data: times}, "*")
        });
      }
    } catch (e) {
      this.error = "There was a problem with the playback of this video."
    }
  }
  ,
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
;
</script>
